import { gql } from "@apollo/client";

export const GET_ITEM_CATEGORIES = gql`
  query item_categories($where: dashboard_reference_bool_exp!) {
    dashboard_reference(order_by: { reference_label: asc }, where: $where) {
      reference_value
      reference_label
    }
  }
`;


export const GET_ORDER_AHEAD_LOCATIONS = gql`
  query GetLocationsOrderAhead($where: locations_order_ahead_bool_exp) {
    locations_order_ahead(where: $where, order_by: { name: asc }) {
    category
    created_at
    digital_surcharge_percentage
    dynamic_descriptor
    event_id
    event {
      id
      name
    }
    id
    is_active
    is_tips
    last_updated_by
    location_type
    name
    payment_processor_id
    updated_at
    url_guid
    vendor_id
    zone
    vendor {
      id
      name
    }
    payment_processor_config {
      is_active
      id
      config
      payment_processor
    }
  }
}
`;

export const GET_ORDER_AHEAD_LOCATION_BY_ID = gql`
  query GetOrderAheadLocationById($id: Int!) {
    locations_order_ahead_by_pk(id: $id) {
    category
    created_at
    digital_surcharge_percentage
    dynamic_descriptor
    event_id
    event {
      id
      name
    }
    id
    is_active
    is_tips
    tip_percentage_1
    tip_percentage_2
    tip_percentage_3
    last_updated_by
    location_type
    description
    logo_url
    background_url
    name
    payment_processor_id
    updated_at
    url_guid
    vendor_id
    zone
    is_pickup
    pickup_note
    vendor {
      id
      name
    }
    payment_processor_config {
      is_active
      id
      config
      payment_processor
    }
  }
  }
`;
